<template>
  <div class="modal-card" style="width: auto">
    <b-loading
      :is-full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <header class="modal-card-head">
      <p class="modal-card-title has-text-centered">
        {{ $t("buyNowPayLater.addUser") }}
      </p>
    </header>

    <section class="modal-card-body">
      <p v-html="$t('buyNowPayLater.buyNowPayLaterInstruction')"></p>

      <hr />

      <b-field :label="$t('buyNowPayLater.email')" label-position="on-border">
        <b-input
          v-model="email"
          placeholder="email@email.com"
          @keyup.enter.native="findUser"
          @input="clearUserData()"
        ></b-input>

        <p class="control">
          <button class="button is-info" @click="findUser">
            {{ $t("buyNowPayLater.search") }}
          </button>
        </p>
      </b-field>

      <p v-if="user._id">
        <b-icon icon="check" type="is-success" size="is-medium"></b-icon>
        {{ `${$t("buyNowPayLater.userFound")}: ${user.name} ${user.surname}` }}
      </p>
    </section>

    <footer class="modal-card-foot">
      <span>
        <button class="button" type="button" @click="$parent.close()">
          {{ $t("common.close") }}
        </button>

        <button
          class="button is-primary"
          type="button"
          :disabled="!user._id"
          @click="addUserToBuyNowPayLaterList"
        >
          {{ $t("buyNowPayLater.add") }}
        </button>
      </span>
    </footer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";
import { mask } from "../../mixins/mask";

export default {
  mixins: [common, mask],

  data() {
    return {
      isLoading: false,
      email: "",
      user: {
        _id: null,
        name: "",
        surname: ""
      }
    };
  },

  methods: {
    findUser() {
      if (!this.email) {
        this.alertError({ message: "INVALID_EMAIL" });
        return;
      }

      this.isLoading = true;
      this.$store
        .dispatch("findUser", this.email)
        .then(res => {
          if (res.data.result === "error") {
            this.clearUserData();
            this.alertError(res.data);
          } else {
            this.user = {
              _id: res.data.payload.user._id,
              name: res.data.payload.user.personalInfo.name,
              surname: res.data.payload.user.personalInfo.surname
            };
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    clearUserData() {
      this.user = {
        _id: null,
        name: "",
        surname: ""
      };
    },

    addUserToBuyNowPayLaterList() {
      this.isLoading = true;
      this.$store
        .dispatch("addUserToBuyNowPayLaterList", {
          storeId: this.storeBeingManaged._id,
          user: this.user
        })
        .then(res => {
          if (res.data.result === "ok") {
            this.$buefy.toast.open({
              message: this.$t("buyNowPayLater.userAdded"),
              type: "is-success",
              position: "is-bottom",
              duration: 5000
            });
            this.clearUserData();
            this.email = "";
          } else {
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },

  computed: {
    ...mapGetters(["storeBeingManaged"])
  }
};
</script>

<style scoped>
.vti__dropdown-list {
  z-index: 10;
}
</style>
